module.exports = __webpack_public_path__ + "static/media/immovable.4c4eb6c4.svg";